import { Box, Grid, Button, CircularProgress } from '@mui/material';
import MDTypography from 'components/MDTypography/index';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentPage, fetchUsersDetails } from '../../stores/sensor/sensorStore';
import { UserCard } from './UserCard';

export const UsersList = () => {
  const dispatch = useDispatch();
  // Fixed: Correct selector path and property name
  const { users, loading } = useSelector(state => state.users);
  // console.log(users);
  const navigate = useNavigate();

  const [snackbarState, setSnackbarState] = useState({
    snackbarOpen: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, snackbarOpen } = snackbarState;

  useEffect(() => {
    dispatch(setCurrentPage('users-list'));
    dispatch(fetchUsersDetails());
  }, [dispatch]);

  const handleSnackbarClose = () => {
    setSnackbarState({ ...snackbarState, snackbarOpen: false });
  };

  const getDisplayTitle = 'Manage Users';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
      {/* ===== HEADER===== */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <MDTypography variant="h4" sx={{ ml: 0.2, color: 'black' }}>
          {getDisplayTitle}
        </MDTypography>
      </Box>

      {/* ===== MAIN CONTENT ===== */}
      <Box sx={{ display: 'flex', flexDirection: 'row', minWidth: 0 }}>
        <Box sx={{ width: '100%', minWidth: 0 }}>
          {/* ===== ADD USER BUTTON ===== */}
          <Box mb={1} sx={{ width: '100%' }}>
            {/* ===== FILTER COMPONENT ===== */}
            {/* <DevicesListFilter area={false} floor={false} building={false} status={false} />  */}
            <Button onClick={() => navigate('/manage-users/new')}>+ Add New User</Button>
          </Box>

          {/* ===== LOADING STATE ===== */}
          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {/* ===== Users GRID ===== */}
          {!loading && users && users.length > 0 && (
            <Grid
              className="usersListContainer"
              sx={{
                display: 'flex',
                alignItems: 'start',
                height: 'fit-content',
                overflow: 'auto',
                flexWrap: 'wrap',
                overflowX: 'hidden',
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
              }}
              margin={0}>
              {users.map(user => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                  xl={3}
                  key={user.id}
                  sx={{
                    lineHeight: 0,
                    position: 'relative',
                    marginBottom: '1rem',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'start' },
                    p: '1rem',
                  }}>
                  <UserCard
                    className="userCard"
                    id={user.id}
                    username={user.username}
                    firstName={user.first_name}
                    lastName={user.last_name}
                    fullName={user.full_name}
                    phone={user.phone}
                    email={user.email}
                    role={user.role}
                    roleDisplay={user.role_display}
                    buildingPermissions={user.building_permissions}
                    buildingNames={user.building_names}
                    customerCount={user.customer_count}
                    hasPermissions={user.has_permissions}
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {/* ===== EMPTY STATE ===== */}
          {!loading && users && users.length === 0 && (
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <MDTypography variant="h6" color="text">
                No users to display
              </MDTypography>
              <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                Contact your administrator for more details or click "Add New User" to get started
              </MDTypography>
            </Box>
          )}

          {/* ===== ERROR STATE ===== */}
          {!loading && !users && (
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <MDTypography variant="h6" color="error">
                Failed to load users
              </MDTypography>
              <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                Please try refreshing the page
              </MDTypography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
